module.exports = __webpack_public_path__ + "img/logo_easyparcel_small.e245de8d.png";